import React,{useState,useEffect} from "react";
import '../../Styles/Components/Persons/PersonList.css';
import Header from "../PublicForms/Header.js";
import Navigation_Bar from "../PublicForms/Navigation_Bar";
import isTokenExpired from "../PublicForms/isTokenExpired.js";
import {useNavigate } from "react-router-dom";


const Analysis = ()=>
{
    const[width, setWidth] = useState(0);
    const[openNav, setOpenNav] = useState(false);
    const Navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('token')) {
          const token = localStorage.getItem('token');
          if (isTokenExpired(token)) {
            localStorage.removeItem('token');
            Navigate("/login");
        } else {
            // setUser(JSON.parse(localStorage.getItem('user')));
          }
        } else {
            Navigate("/login");
        }
      }, []);
    
      useEffect(() => {
        function handleResize() {
          setWidth(window.innerWidth)
        }
        
        window.addEventListener("resize", handleResize)
        
        handleResize()
        
        
      }, []);

      const handleNave = ()=>
      {
          setOpenNav(!openNav);
  
      }

      const handleNaveForm = ()=>
        {
            if(!openNav)
            {
                setOpenNav(!openNav)
            }
        }

      if(width>999)
      {
        return(
          <div className="personLst-all">
                  <Header />

                          
              <div className="navClass">
                      <Navigation_Bar />
                  
              </div>
                  
              <div className="personLst">
                
                  <p className="p-analysis"> به برنامه اشتراک موعود خوش آمدید</p>

              </div>
          </div>
      );
      }else
      {
        return(

          <div className="personLst-all-responsive">
               
               <div className= {openNav? "navClass" : "navClass navClassOpen"}>
                                

                  <Navigation_Bar />
                                
              </div>
            <div className="personLst-all">
                    <Header handleNave={handleNave}/>
                    
                <div className="personLst" onClick={()=>handleNaveForm()}>
                  
                    <p className="p-analysis"> به برنامه اشتراک موعود خوش آمدید</p>

                </div>
            </div>

          </div>
          
      );
      }
         
}

export default Analysis;